const CustomSelect = {
  set() {
    $(".custom-select-js:not(.custom-selected-js)").wrap("<span class='custom-select'></span>")
    $(".custom-select-js").addClass("custom-selected-js")
    $(".custom-select--small-js")
      .closest(".custom-select")
      .addClass("custom-select--small")
    return $(".custom-select-js")
      .focus(function() {
        $(this)
          .closest(".custom-select")
          .addClass("has-focus")
      })
      .blur(function() {
        $(this)
          .closest(".custom-select")
          .removeClass("has-focus")
      })
  },
  initialize() {
    $(document).on("turbolinks:load", () => this.set())
  }
}

export default CustomSelect
